module.exports = __webpack_public_path__ + "img/scales.b8b83c7c.svg";